/**
 * Il testo formattato dell'editor visuale gira nella stessa pagina del CMS:
 * un `<img onerror=…>` o uno `<script>` arrivati da un contenuto importato
 * girerebbero con i permessi di chi lo sta modificando. Per questo il testo si
 * ripulisce prima di mostrarlo. Ripulire toglie anche gli script legittimi
 * del vecchio sito: `stripped` lo dice, così l'interfaccia può avvisare.
 */
const DROPPED_TAGS = ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta', 'base', 'form', 'noscript']

export interface SanitizedHtml {
  html: string
  stripped: boolean
}

export function sanitizeHtml(source: string): SanitizedHtml {
  if (!source.trim()) return { html: '', stripped: false }
  const doc = new DOMParser().parseFromString(`<body>${source}</body>`, 'text/html')
  let stripped = false
  for (const tag of DROPPED_TAGS) {
    doc.body.querySelectorAll(tag).forEach((node) => { node.remove(); stripped = true })
  }
  doc.body.querySelectorAll('*').forEach((node) => {
    for (const attribute of [...node.attributes]) {
      const name = attribute.name.toLowerCase()
      const value = attribute.value.trim().toLowerCase()
      if (name.startsWith('on') || ((name === 'href' || name === 'src' || name === 'xlink:href') && /^(javascript|data:text\/html|vbscript):/.test(value.replace(/\s+/g, '')))) {
        node.removeAttribute(attribute.name)
        stripped = true
      }
    }
  })
  return { html: doc.body.innerHTML, stripped }
}

/** Il testo in chiaro di un HTML, per le anteprime e per capire se c'è qualcosa. */
export function plainTextOf(html: string): string {
  if (!html) return ''
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html')
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim()
}
